import { capitalize } from 'lodash';
import { Option } from 'components/common/types/DropdownItem.types';
import { Network } from 'components/common/types/Deal.types';
import { NetworkReferenceResponse } from 'store/userOptions/reducer.types';
import { sortByName } from 'utils/sortByName';

const transformNetworkToOption = (networks: Network[], groupCode: string): Option[] => {
  return sortByName(
    networks.map(({ code, name }) => ({
      code,
      name,
      selectable: true,
      parentCode: groupCode,
    })),
  );
};

export const transformNetworkData = (networkReferenceData: NetworkReferenceResponse[]): Option[] => {
  if (!networkReferenceData || !Array.isArray(networkReferenceData)) {
    return [];
  }

  return sortByName(
    networkReferenceData.reduce<Option[]>((acc, group) => {
      if (group.networks && group.networks.length > 0) {
        const children = transformNetworkToOption(group.networks, group.code);

        acc.push({
          code: group.code,
          name: capitalize(group.name),
          selectable: false,
          children,
        });
      }
      return acc;
    }, []),
  );
};
